const mwLogo = `%c
 ▄█████████████████▄
▟███████████████████▙
███▛     ▜█▛     ▜███
███▏             ▕███
███               ███
███               ███
███▏             ▕███
███▙▂▂▂▟▙▂▂▂▟▙▂▂▂▟███
█████████████████████
▜███( milkywire )███▛
 ▀█████████████████▀
%c
https://www.milkywire.com/page/work-with-us

    ^ Apply here ^
`;

// eslint-disable-next-line
const easterEgg = () => console.log(mwLogo, 'font-family: courier', 'font-family: helvetica');

export default easterEgg;
